import { useCallback, useEffect, useRef, useState } from 'react';
import { GetFilteredVendorClientTrackingsAPI } from '../../../../../../Services';
import { GetParams, showError } from '../../../../../../Helper';
import { useTranslation } from 'react-i18next';
import { VendorsTranslationPath } from '../../../../VendorsView/I18n/VendorsLocale';

export const useFetchClientOffer = () => {
  const [filter, setFilter] = useState({
    pageIndex: 1,
    pageSize: 25,
    contactId: +GetParams('id'),
  });

  const firstFetchEmpty = useRef(true);
  const [data, setData] = useState({ result: [], totalCount: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(VendorsTranslationPath);
  const getFilteredVendorClientTrackings = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await GetFilteredVendorClientTrackingsAPI(filter);
      if (firstFetchEmpty.current && !!response.totalCount) {
        firstFetchEmpty.current = false;
      }
      setData(response);
    } catch (error) {
      showError(t('something_went_wrong'));
    } finally {
      setIsLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    getFilteredVendorClientTrackings();
  }, [getFilteredVendorClientTrackings]);
  return {
    result: data.result,
    totalCount: data.totalCount,
    isLoading,
    filter,
    setFilter,
    firstFetchEmpty: firstFetchEmpty.current,
  };
};
